import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
import { Popup } from "../../../internal/Popup";
import { ComboBoxMenu } from "../../../internal/CustomComboBox";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { TokenInputDataTids } from "../TokenInput";
export var TokenInputMenu = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TokenInputMenu, _React$Component);

  function TokenInputMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.menu = null;

    _this.getMenuRef = function () {
      return _this.menu;
    };

    _this.getPopupMargin = function () {
      var paddingY = parseInt(_this.theme.tokenInputPaddingY, 10) || 0;
      var outlineWidth = parseInt(_this.theme.controlOutlineWidth, 10) || 0;
      var marginY = parseInt(_this.theme.tokenMarginY, 10) || 0;
      return paddingY + outlineWidth + marginY;
    };

    _this.menuRef = function (node) {
      return _this.menu = node;
    };

    return _this;
  }

  var _proto = TokenInputMenu.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = theme;
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: ThemeFactory.create({
          popupMargin: _this2.getPopupMargin() + 'px',
          popupBackground: _this2.theme.tokenInputMenuPopupBg
        }, theme)
      }, _this2.renderMain());
    });
  };

  _proto.getPopupMarginSize = function getPopupMarginSize(t) {
    switch (this.props.size) {
      case 'large':
        return t.tokenInputPopupMarginLarge;

      case 'medium':
        return t.tokenInputPopupMarginMedium;

      case 'small':
      default:
        return t.tokenInputPopupMarginSmall;
    }
  };

  _proto.renderMain = function renderMain() {
    var _this$props = this.props,
        loading = _this$props.loading,
        maxMenuHeight = _this$props.maxMenuHeight,
        renderTotalCount = _this$props.renderTotalCount,
        totalCount = _this$props.totalCount,
        opened = _this$props.opened,
        items = _this$props.items,
        renderNotFound = _this$props.renderNotFound,
        renderItem = _this$props.renderItem,
        onValueChange = _this$props.onValueChange,
        renderAddButton = _this$props.renderAddButton,
        anchorElement = _this$props.anchorElement,
        menuWidth = _this$props.menuWidth,
        menuAlign = _this$props.menuAlign;
    return /*#__PURE__*/React.createElement(Popup, {
      id: this.props.popupMenuId,
      "data-tid": TokenInputDataTids.tokenInputMenu,
      opened: !!opened,
      positions: ['bottom left', 'top left'],
      anchorElement: anchorElement,
      popupOffset: menuAlign === 'left' ? parseInt(this.theme.tokenInputPopupOffset) : 8 + parseInt(this.theme.tokenInputPopupOffset),
      margin: menuAlign === 'left' ? 1 : parseInt(this.getPopupMarginSize(this.theme)),
      hasShadow: true,
      width: menuAlign === 'cursor' ? 'auto' : menuWidth,
      withoutMobile: true
    }, /*#__PURE__*/React.createElement(ComboBoxMenu, {
      items: items,
      loading: loading,
      maxMenuHeight: maxMenuHeight,
      onValueChange: onValueChange,
      opened: opened,
      refMenu: this.menuRef,
      renderTotalCount: renderTotalCount,
      renderItem: renderItem,
      renderNotFound: renderNotFound,
      totalCount: totalCount,
      renderAddButton: renderAddButton
    }));
  };

  return TokenInputMenu;
}(React.Component);
TokenInputMenu.__KONTUR_REACT_UI__ = 'TokenInputMenu';
TokenInputMenu.displayName = 'TokenInputMenu';